import React from 'react';
import { googleRatingData, formatRatingDisplay } from '../data/GoogleRating';

// You can later add props for dynamic ratings if needed
const GoogleRatingBanner = () => {
  return (
    <div className="w-full bg-gradient-to-r from-yellow-50 via-yellow-100 to-yellow-50 border-b border-yellow-200">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex gap-3 justify-center items-center py-2 text-sm">
          {/* Google G Logo */}
          <div className="flex-shrink-0">
            <svg
              className="w-4 h-4"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
          </div>

          {/* Star Rating */}
          <div className="flex gap-1 items-center">
            {[1, 2, 3, 4, 5].map((star, index) => (
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="#FBBF24"
                className="w-4 h-4 transition-transform duration-200 transform hover:scale-110">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.18c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.175 0l-3.385 2.46c-.784.57-1.838-.196-1.54-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.045 9.394c-.783-.57-.38-1.81.588-1.81h4.18a1 1 0 00.95-.69l1.286-3.967z" />
              </svg>
            ))}
          </div>

          {/* Rating Text */}
          <div className="font-medium text-gray-700">
            <span className="font-bold text-gray-900">
              {formatRatingDisplay(googleRatingData.rating)}
            </span>{' '}
            rating from{' '}
            <span className="font-bold text-gray-900">
              {googleRatingData.reviewCount}
            </span>{' '}
            reviews
          </div>

          {/* Review Link */}
          <a
            href={googleRatingData.reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-blue-600 transition-colors duration-200 hover:text-blue-800 group">
            <span className="border-b border-blue-300 group-hover:border-blue-600">
              Read Reviews
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ml-1 w-4 h-4 transition-transform duration-200 transform group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

// Removed problematic CSS animation that was causing conflicts with Framer Motion

export default GoogleRatingBanner;
